// Что можно писать в лог об упавшем запросе.
//
// Объект ошибки axios несёт `config` целиком: сериализованное тело запроса и заголовки,
// включая Authorization. Для CRM это телефоны и email контактов, для формы входа — email
// и пароль. Поэтому в лог идёт не ошибка, а вот эта выжимка: метод, путь, код, причина.
// Всё остальное не «маскируется», а просто не попадает сюда — маскировать по списку полей
// значит однажды забыть новое поле.
const pathOf = (url = '') => String(url).split('?')[0];

export const logSafeError = (error) => ({
  method: error?.config?.method || null,
  // Строка запроса отбрасывается: персональных данных там быть не должно, но лог — не то
  // место, где это стоит проверять на доверии.
  url: pathOf(error?.config?.url),
  status: error?.response?.status ?? null,
  code: error?.code || null,
  message: error?.message || null,
});
